export default __webpack_public_path__ + "static/media/github.8af275a9.svg";